module.exports = {
	"ha": "iha",
	"id": 6.1,
	"report": {
		"ha": "Interior Health",
		"group": "HSDA",
		"period": "2017 Q2–2018 Q1",
		"lastYear": "2018",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 680,
			"height": 400,
			"marginLeft": 100,
			"marginRight": 180,
			"marginBottom": 80,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 6.1</span>                 <span style=\"display: table-cell;\">PCS Components for Interior Health, 2017 Q2–2018 Q1 <sup style=\"font-size: 10px;\">10</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2016",
					"2016",
					"2016",
					"2017",
					"2017",
					"2017",
					"2017",
					"2018"
				],
				"tickPositions": [
					0,
					3,
					7
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 5,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "Percentage",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "<3 CD4 Tests",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					13.043478260869565,
					9.090909090909092,
					13.636363636363635,
					21.052631578947366,
					5.555555555555555,
					0,
					4.761904761904762,
					{
						"y": 10.526315789473683,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\"><3 CD4 Tests</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "<3 Viral Load Tests",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					13.043478260869565,
					9.090909090909092,
					4.545454545454546,
					5.263157894736842,
					0,
					0,
					4.761904761904762,
					{
						"y": 5.263157894736842,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": -10,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\"><3 Viral Load Tests</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "No Baseline Genotype",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					4.3478260869565215,
					4.545454545454546,
					4.545454545454546,
					0,
					0,
					0,
					4.761904761904762,
					{
						"y": 5.263157894736842,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 20,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">No Baseline Genotype</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Baseline CD4 <200/µL",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					30.434782608695656,
					22.727272727272727,
					40.909090909090914,
					52.63157894736842,
					44.44444444444444,
					50,
					33.33333333333333,
					{
						"y": 21.052631578947366,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Baseline CD4 <200/µL</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Non-Recommended ART",
				"pointPlacement": "on",
				"color": "#560054",
				"dashStyle": "Solid",
				"data": [
					4.3478260869565215,
					9.090909090909092,
					4.545454545454546,
					5.263157894736842,
					5.555555555555555,
					0,
					0,
					{
						"y": 0,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#560054",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Non-Recommended ART</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "Non Viral Suppression at 9 Mo.",
				"pointPlacement": "on",
				"color": "#9d070d",
				"dashStyle": "Solid",
				"data": [
					34.78260869565217,
					31.818181818181817,
					27.27272727272727,
					36.84210526315789,
					33.33333333333333,
					27.77777777777778,
					33.33333333333333,
					{
						"y": 31.57894736842105,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#9d070d",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Non Viral Suppression at 9 Mo.</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "n=",
				"visible": false,
				"pointPlacement": "on",
				"color": "#231f20",
				"dashStyle": "Solid",
				"data": [
					23,
					22,
					22,
					19,
					18,
					18,
					21,
					{
						"y": 19,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#231f20",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">n=</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 0,
					"suppressible": true
				}
			}
		]
	},
	"callback": "C:\\Users\\Rafael\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_iha_6_1.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_iha_6_1.json
// module id = 237
// module chunks = 0